import { useCallback } from 'react';

/** Shared snackbar + session-expired handling for store admin pages. */
export function useStoreSession(setSnackbar) {
  const showSnackbar = useCallback(
    (message, severity = 'success') => {
      setSnackbar({ open: true, message, severity });
    },
    [setSnackbar]
  );

  const handleSessionExpired = useCallback(
    (res) => {
      if (String(res?.statusCode || '') === '10003') {
        showSnackbar('Session expired. Please login again.', 'error');
        setTimeout(() => {
          window.location = '/login';
        }, 1500);
        return true;
      }
      return false;
    },
    [showSnackbar]
  );

  return { showSnackbar, handleSessionExpired };
}
